// @flow

import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import { WebsiteDefaultPage as BaseWebsiteDefaultPage } from 'components/Page';
import { PageType } from 'Constants';
import { OriginationFees } from 'data/global/footer/legal/numbered';
import { useImages } from 'hooks';
import { Color, flex, hover, Layout, maxWidthContainer, topBottomMargin, Width } from 'styles';
import { MarketsHero, ResourcesSideBar } from 'components/Content';
import { ImageLoader, Link } from 'components/Gui';

const METADATA = {
  title: 'Financial products to simplify finances, faster',
  description: `At Markets Direct, we’re transforming home equity by creating a fast, simple and transparent process to bring you closer to your financial goals. We'll show you how to use home equity to consolidate debt, pay for home improvement or fund your retirement. It's quick and easy. Let’s unlock the potential of your largest asset.`,
};

const PAGE_TYPE = {
  product: PageType.PRODUCT.NONE,
};

const WebsiteDefaultPage = styled(BaseWebsiteDefaultPage)`
  width: 100% !important;
`;

const Wrapper = styled.div`
  width: 100%;
  ${flex()};
  flex-direction: column;
  ${topBottomMargin([Layout.NAV_HEIGHT_MOBILE, 0], [Layout.NAV_HEIGHT_DESKTOP, 0], [Layout.NAV_HEIGHT_DESKTOP, 0])};
`;

const Data = [
  {
    title: 'Forms',
    image: 'logo-1',
    links: ['Deposit', 'Withdraw Funds', 'White Label', 'Forms', 'VPS Solution'],
  },
  {
    title: 'Market Data',
    image: 'logo-2',
    links: ['Forex Reports', 'Economic Calendar', 'News'],
  },
  {
    title: 'Education',
    image: 'logo-3',
    links: ['Trader’s Guide', 'User Manual', 'FAQ'],
  },
];

const NewData = [
  {
    title: 'Getting Started',
  },
  {
    title: 'Forms & Documents',
  },
  {
    title: 'Regulatory',
    links: [
      {
        title: 'Terms & Conditions',
      },
    ],
  },
];

const Content = styled.div`
  width: 100%;
  background: white;

  > div {
    padding: 40px 0;
    ${maxWidthContainer(1080)};
    ${flex()};
    flex-direction: column;

    @media (min-width: ${Width.BREAK_MD}px) {
      ${flex('flex-start', 'flex-start')};
      flex-direction: row;
    }
  }
`;

const PageContainer = ({ data }: { data: any }) => {
  const getImage = useImages(data);

  return (
    <WebsiteDefaultPage
      page={PAGE_TYPE}
      metaData={{
        ...METADATA,
        image: getImage('resources'),
      }}
      footerLegal={{
        numbered: OriginationFees,
      }}>
      <Wrapper>
        <MarketsHero
          title="RESOURCES"
          blurb="Hello? How can we help you?"
          image={{
            name: 'resources',
          }}
          images={data}
        />
        <Content>
          <div>
            <ResourcesSideBar sectionIndex={0} showLinksList={2} />
          </div>
        </Content>
      </Wrapper>
    </WebsiteDefaultPage>
  );
};

export default PageContainer;

export const query = graphql`
  query {
    imageToWebP: allFile(filter: { relativeDirectory: { eq: "pages/resources" }, extension: { nin: ["svg", "gif"] } }) {
      edges {
        node {
          ...ImageToWebP
        }
      }
    }
    otherImage: allFile(filter: { relativeDirectory: { eq: "pages/resources" }, extension: { in: ["svg", "gif"] } }) {
      edges {
        node {
          ...OtherImage
        }
      }
    }
  }
`;
